export default __webpack_public_path__ + "static/Iluminacao-f664084a008fb6bcd121960d232d08df.svg";